import React, { useEffect, useState } from 'react'
import YumTabs from '../YumTabs/YumTabs'
import YumTab from '../YumTabs/YumTab/YumTab'
import { t } from 'ttag'
import { store } from '../../index'
import { push } from 'connected-react-router'
import { GoalWithProgress, UserProfileDto } from '../../services/api.types'
import YumChatButton from '../../views/ChallengeChat/components/YumChatButton/YumChatButton'
import { getFullName } from '../../common/helpers/translations'

export interface IChallengeMeProps {
  userDto: UserProfileDto
  tab: string
  goal?: GoalWithProgress
  currentRoute: Partial<Location>
}

export enum ChallengeTab {
  INFO = 0,
  RANKING = 1,
  CHAT = 2,
}

const getChallengeTabNumber = (value: string) => {
  switch (value) {
    default:
    case 'info':
      return ChallengeTab.INFO
    case 'ranking':
      return ChallengeTab.RANKING
    case 'chat':
      return ChallengeTab.CHAT
  }
}

export default function YumChallengeTabs(props: IChallengeMeProps) {
  const { tab, goal, userDto, currentRoute } = props
  if (!goal) return <>Goal not found</>
  const { participantsCount, participating } = goal
  const { userId, firstName, lastName, email } = userDto
  const name = getFullName(firstName, lastName, email)

  const [activeChallengeTab, setActiveChallengeTab] = useState(getChallengeTabNumber(tab))

  useEffect(() => {
    setTimeout(() => {
      document.body.classList.add('show-back-btn')
      document.body.classList.add('challenge-view')
    }, 0)
    return function cleanup() {
      document.body.classList.remove('show-back-btn')
      document.body.classList.remove('challenge-view')
      document.body.classList.remove('challenge-view__chat')
    }
  }, [])

  useEffect(() => {
    const pathParts = currentRoute.pathname ? currentRoute.pathname.split('/') : []
    const newTab = pathParts[3]
    if (newTab) setActiveChallengeTab(getChallengeTabNumber(newTab))
  }, [currentRoute.pathname])

  useEffect(() => {
    if (activeChallengeTab === ChallengeTab.CHAT) {
      document.body.classList.add('challenge-view__chat')
    } else {
      document.body.classList.remove('challenge-view__chat')
    }
  }, [activeChallengeTab])

  const redirectTab = (tab: string) => {
    store.dispatch(push(`/challenges/${goal.id}/${tab}`))
  }

  const handleTypeTabChange = (event: React.ChangeEvent<{}>, value: ChallengeTab) => {
    setActiveChallengeTab(value)
    switch (value) {
      case ChallengeTab.INFO:
        redirectTab('info')
        break
      case ChallengeTab.RANKING:
        redirectTab('ranking')
        break
      case ChallengeTab.CHAT:
        redirectTab('chat')
        break
    }
  }

  return (
    <div style={{ paddingBottom: activeChallengeTab === ChallengeTab.CHAT ? 0 : '24px' }}>
      <YumTabs value={activeChallengeTab} onChange={handleTypeTabChange}>
        <YumTab label={t`Info`} value={ChallengeTab.INFO} />
        <YumTab label={t`Ranking`} value={ChallengeTab.RANKING} />
        {goal.chatEnabled && (
          <YumChatButton
            tab={ChallengeTab.CHAT}
            userId={userId}
            goalId={goal.id}
            name={name}
            connect={participantsCount > 0 && participantsCount < 2000}
            participating={participating}
            currentRoute={currentRoute}
          />
        )}
      </YumTabs>
    </div>
  )
}
